import { combineReducers } from '@ynap/reducer-utils';
import { default as userFetchedFromSF } from './reducers/userFetchedFromSF';
import { default as user } from './reducers/user';

const userFetchedFromSFReducer = combineReducers({ userFetchedFromSF, user });

export default userFetchedFromSFReducer;
